import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import config from 'config/config.js'

import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { saveToDo } from 'redux/toDos'
import { Icon, Image, Message, Segment, Table } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { toDos, toDosLoading } = state.toDos
  const { currentUser } = state.user
  const filteredToDos = toDos
    .filter((toDo) => toDo.user.id === currentUser.id && !toDo.done)
    .slice(0, ownProps.compact ? 2 : 1000)
  const numToDos = filteredToDos.length
  return { filteredToDos, numToDos, toDosLoading }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      saveToDo,
    },
    dispatch
  )
}

class ToDos extends React.Component {
  headerActions() {
    const { push } = this.props
    return [
      {
        icon: 'chevron right',
        color: config.semantic_ui.primary_color,
        content: I18n.t('admin.todo.action'),
        onClick: (event) => {
          event.preventDefault()
          push(config.nodes.todo)
        },
      },
    ]
  }

  backActions() {
    const { push } = this.props
    return [
      {
        icon: 'chevron left',
        secondary: true,
        content: I18n.t('global.back'),
        onClick: (event) => {
          event.preventDefault()
          push(config.nodes.dashboard)
        },
      },
    ]
  }

  toDoItems() {
    // redux
    const { filteredToDos } = this.props
    // actions
    const { push, saveToDo } = this.props

    return filteredToDos.map((toDo, index) => (
      <Table.Row key={index}>
        <Table.Cell collapsing>
          <Image
            size="mini"
            src={
              toDo.user.avatar && config.api_url + toDo.user.avatar.thumb_url
            }
          />
        </Table.Cell>
        <Table.Cell>
          <strong>{toDo.user.name}</strong>{' '}
          {new Date(toDo.created_at).toLocaleString()}
          <br />
          {toDo.text}
        </Table.Cell>
        <Table.Cell
          collapsing
          children={toDo.taggable && toDo.taggable.title_de}
        />
        <Table.Cell
          collapsing
          className="link"
          textAlign="right"
          onClick={() => {
            push(config.nodes.product + toDo.taggable.article_number)
          }}>
          {toDo.taggable && toDo.taggable.article_number}&nbsp;<Icon
            name="chevron right"
            link
            color="orange"
          />
        </Table.Cell>
        <Table.Cell
          collapsing
          className="link"
          onClick={(event) => {
            event.preventDefault()
            saveToDo({ ...toDo, done: true })
          }}>
          <Icon link {...config.icons.confirm} />{' '}
          {I18n.t('admin.todo.mark_done')}
        </Table.Cell>
      </Table.Row>
    ))
  }

  render() {
    const dark = config.theme.dark
    // params
    const { compact } = this.props
    // redux
    const { numToDos, toDosLoading } = this.props

    return toDosLoading ? (
      <ComponentPlaceholder />
    ) : numToDos > 0 ? (
      <div className={classNames(['ToDos', dark && 'inverted'])}>
        <ComponentHeader
          title={I18n.t('admin.todo.title')}
          badge="todo"
          actions={compact ? this.headerActions() : this.backActions()}
        />

        <Segment
          attached
          className={classNames(['payload', 'small', dark && 'inverted'])}>
          <Table
            compact
            size="small"
            singleLine
            basic="very"
            className="spaced"
            inverted={dark}>
            <Table.Body children={this.toDoItems()} />
          </Table>
        </Segment>
      </div>
    ) : (
      <div className="ToDos">
        <Message
          icon="smile"
          success
          header={I18n.t('admin.todo.success_title')}
          content={I18n.t('admin.todo.success_message')}
        />
      </div>
    )
  }
}

ToDos = connect(mapStateToProps, mapDispatchToProps)(ToDos)
export default ToDos



// WEBPACK FOOTER //
// ./src/components/admin/ToDos/ToDos.jsx